import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Skeleton,
} from "@mui/material";
import axios from "axios";
import {
  CurrencyDisplay,
  CurrencyNumberInput,
  DatePicker,
  FormLabel,
  ModalError,
  ModalSuccess,
  PrimaryButton,
  SecondaryButton,
  TextInput,
} from "components";
import moment from "moment";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { formatPayloadDate, getErrors } from "utils";

const ModalFormPayment = ({ open, onClose, getDataTable, userLogin }) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [initialBalance, setInitialBalance] = useState(0);
  const [remainingBalance, setRemainingBalance] = useState(0);
  const [payload, setPayload] = useState({
    invoice_date: moment(),
    value: 0,
    notes: "",
  });

  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleChangeValue = value => {
    if (value > initialBalance) {
      ModalError("Payment value is greater than remaining balance");
      handleChangePayload(0, "value");
      setRemainingBalance(initialBalance);
    } else {
      handleChangePayload(value, "value");
      setRemainingBalance(initialBalance - value);
    }
  };
  const handleChangeRemainingBalance = () => {
    setRemainingBalance(initialBalance - payload?.value);
  };

  const getPaymentBalance = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/composer/transaction/v2/balance/payment`,
        { headers }
      );
      const resBalance = res?.data?.data?.balance;
      setInitialBalance(resBalance);
      setRemainingBalance(resBalance);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const handleSubmit = async () => {
    const modifiedPayload = {
      ...payload,
      invoice_date: formatPayloadDate(payload?.invoice_date),
    };
    try {
      setLoadingButton(true);
      await axios.post(
        `${hardBaseUrl}/composer/transaction/v2/payment`,
        modifiedPayload,
        { headers }
      );
      ModalSuccess("Successfully Create Transaction").then(() =>
        getDataTable()
      );
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingButton(false);
      onClose();
    }
  };

  useEffect(() => {
    getPaymentBalance();
  }, []);
  useEffect(() => {
    if (payload?.value) {
      handleChangeRemainingBalance();
    }
  }, [payload?.value]);

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>Request Payment</DialogTitle>
      <DialogContent dividers>
        {loadingPage ? (
          <Grid container direction="column" rowSpacing={2}>
            {Object.keys(payload)?.map((_, index) => (
              <Grid item key={index}>
                <Box mb="8px">
                  <Skeleton variant="rounded" width="40%" height={25} />
                </Box>
                <Skeleton variant="rounded" width="100%" height={30} />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Grid container direction="column" rowSpacing={2}>
            {MockFieldForm.map(
              ({ key, title, type, multiline, rows, disabled }) => (
                <Grid item key={key}>
                  <FormLabel label={title} />
                  {type === "date" ? (
                    <DatePicker
                      value={payload?.[key]}
                      onChange={date => handleChangePayload(date, key)}
                    />
                  ) : type === "currency" ? (
                    <CurrencyNumberInput
                      value={payload?.[key]}
                      onChange={handleChangeValue}
                      startAdornment="Rp"
                      decimalScale={2}
                      helperText={
                        <CurrencyDisplay
                          value={
                            payload?.[key] ? remainingBalance : initialBalance
                          }
                          decimalScale={2}
                          prefix="Available Balance: Rp "
                          suffix=",-"
                          textAlign="left"
                        />
                      }
                    />
                  ) : (
                    <TextInput
                      placeholder={title}
                      value={
                        disabled ? userLogin?.publisher?.name : payload?.[key]
                      }
                      onChange={e => handleChangePayload(e?.target?.value, key)}
                      disabled={disabled}
                      multiline={multiline}
                      rows={rows}
                    />
                  )}
                </Grid>
              )
            )}
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          label="Cancel"
          disabled={loadingPage}
          onClick={onClose}
        />
        <PrimaryButton
          label={loadingButton ? "Saving" : "Save"}
          loading={loadingButton}
          disabled={loadingPage || loadingButton}
          onClick={handleSubmit}
        />
      </DialogActions>
    </Dialog>
  );
};

const MockFieldForm = [
  {
    title: "Publisher",
    key: "contract_number",
    disabled: true,
  },
  {
    title: "Date",
    key: "invoice_date",
    type: "date",
  },
  {
    title: "Value",
    key: "value",
    type: "currency",
  },
  {
    title: "Notes",
    key: "notes",
    multiline: true,
    rows: 4,
  },
];
export default ModalFormPayment;
